// extracted by mini-css-extract-plugin
module.exports = {"everythingYouNeedContainer":"style-module__everythingYouNeedContainer___1ErwX"};